import { mergeStyleSets } from "@fluentui/react";
import { IDonutChartStyles, IVerticalBarChartStyles } from "@fluentui/react-charting";
import { CSSProperties } from "react";

export const CUSTOMER_VIEW_STYLES = {
  COMMON_STYLES: {
    CLASS_NAMES: mergeStyleSets({
      customCardContainer: {
        columnGap: 10,
        display: "flex",
        margin: 8,
        flex: 1,
      } as CSSProperties
    }),
    CSS_STYLES: {
      donutChart: {
        legendContainer: { width: "100%", maxWidth: 400, "& div": { marginLeft: 0 } },
        root: { marginBottom: 12, marginTop: 14 }
      } as IDonutChartStyles,
      verticalBarChart: {
        legendContainer: { width: "100%", maxWidth: 400, "& div": { marginLeft: 0 } },
        root: { marginBottom: 24, marginTop: 28, height: 250 },
        opacityChangeOnHover: undefined,
        barLabel: undefined
      } as IVerticalBarChartStyles
    },
    COUNT_ANNOTATION: mergeStyleSets({
      cardContent: {
        paddingLeft: "12px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start"
      } as CSSProperties,
      overviewContainer: { paddingTop: "5px", paddingBottom: "5px" } as CSSProperties,
      mainContainerStyle: {
        display: "contents",
        width: "100%"
      } as CSSProperties,
      metricsContainer: { display: "flex", flexDirection: "row", flexWrap: "wrap", maxWidth: "80%", gap: "16px" } as CSSProperties
    })
  }
};
